// src/components/AnalyticsPlatformCharts.js

import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip
} from 'recharts';
import { formatDateTick, CHART_COLORS, TOOLTIP_STYLE } from './analyticsChartUtils';

function AnalyticsPlatformCharts({ dailyActiveUsers }) {
  if (!dailyActiveUsers || dailyActiveUsers.length === 0) return null;

  return (
    <div className="analytics-chart-card">
      <div className="analytics-chart-title">Users by last-active day</div>
      <div className="analytics-chart-subtitle">
        Each user counts once, on their most recent active day — older days undercount actual activity.
      </div>
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={dailyActiveUsers} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={CHART_COLORS.grid} vertical={false} />
          <XAxis
            dataKey="date"
            stroke={CHART_COLORS.axis}
            fontSize={12}
            tickFormatter={formatDateTick}
            interval="preserveStartEnd"
            minTickGap={32}
            tickLine={false}
          />
          <YAxis stroke={CHART_COLORS.axis} fontSize={12} allowDecimals={false} width={35} tickLine={false} />
          <Tooltip contentStyle={TOOLTIP_STYLE} labelFormatter={formatDateTick} formatter={(v) => [v, 'Users']} />
          <Line
            type="monotone"
            dataKey="count"
            stroke={CHART_COLORS.series}
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default AnalyticsPlatformCharts;
